import { FETCH_FLEET_MEMBERS } from 'actions/user';

const initialState = {
  isLoading: false,
  FleetMember: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};
const fleetMemberReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_FLEET_MEMBERS.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_FLEET_MEMBERS.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        FleetMember: payload.data.results,
        page: payload.data.page,
        limit: payload.data.limit,
        totalPages: payload.data.totalPages,
        total: payload.data.totalResults,
      };
    }

    case FETCH_FLEET_MEMBERS.FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }
    default:
      return { ...state };
  }
};
export default fleetMemberReducer;
